import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ApisService } from '@core/services/apis.service';
import { LoadingService } from '@core/services/loading.service';
import { TranslateService } from '@ngx-translate/core';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-edit-open-screen',
  templateUrl: './edit-open-screen.component.html',
  styleUrls: ['./edit-open-screen.component.scss']
})
export class EditOpenScreenComponent implements OnInit {
formData: any = {
   name_ar: '',
  name_en: '',
  body_ar: '',
  body_en: '',
  image: null,
};
// Declare formData property 
    public arrCountries:any[] = [];
    public country:any[] = [];
      public currentPage = 1; 
  public categories : any
  public totalItems = 0;
subCategories: any[] = [];

  imagePreview: string | ArrayBuffer | null = null;
    constructor(private router: Router, private apisService: ApisService,
        private route: ActivatedRoute,    private loading : LoadingService
        ,private translate: TranslateService
    ) { }
  
    ngOnInit(): void {

      // this.postCountires();
    const bookId = this.route.snapshot.paramMap.get('id');
  if (bookId) {
    this.fetchBookForEdit(+bookId);
  }
    }
fetchBookForEdit(id: number): void {
  this.apisService.getOpenScreensById(id).subscribe({
    next: (res) => {
      const book = res.data;

      this.formData.name_ar = book.body_ar ? book.body_ar : ''; // or book.name_ar if exists
      this.formData.name_en = book.body_en ? book.body_en : ''; // or book.name_en if exists
      this.formData.body_ar = book.body_ar;
      this.formData.body_en = book.body_en;
      this.formData.image = null; // Keep null because it's a File input
      this.imagePreview = book.image  || null;
    },
    error: (err) => {
      console.error('Error fetching book:', err);
    },
  });
}


    cancel(): void {
      this.router.navigate(['/open-screen']);
    }
  
    getTranslation(translations: any[], locale: string) {
      return translations.find(translation => translation.locale === locale) || {};
    }

onFileSelected(event: any, type: 'img' | 'book'): void {
  const file = event.target.files[0];
  if (file) {
    if (type === 'img') {
      this.formData.image = file;

      // Preview image
      const reader = new FileReader();
      reader.onload = e => this.imagePreview = e.target?.result;
      reader.readAsDataURL(file);
    } else if (type === 'book') {
      this.formData.bookFile = file;
    }
  }
}



async submitForm(): Promise<void> {
  const formDataToSend = new FormData();

  formDataToSend.append('name_ar', this.formData.name_ar);
  formDataToSend.append('name_en', this.formData.name_en);
  formDataToSend.append('body_ar', this.formData.body_ar);
  formDataToSend.append('body_en', this.formData.body_en);

  if (this.formData.image) {
    // user selected a new file
    formDataToSend.append('image', this.formData.image);
  } else if (typeof this.imagePreview === 'string') {
    // convert existing image URL to File
    const res = await fetch(this.imagePreview);
    const blob = await res.blob();
    const fileName = this.imagePreview.split('/').pop() || 'existing-image.png';
    const file = new File([blob], fileName, { type: blob.type });
    formDataToSend.append('image', file);
  }



  const id = this.route.snapshot.paramMap.get('id');

  this.loading.show();

  this.apisService.editOpenScreen(+id, formDataToSend).subscribe({
    next: (res) => {
      this.loading.hide();
      this.translate.get(['MENU.DASHBOARD.SUCCESS', 'MENU.DASHBOARD.SUCCESS', 'MENU.DASHBOARD.OK'])
        .subscribe(translations => {
          Swal.fire({
            title: translations['MENU.DASHBOARD.SUCCESS'],
            text: translations['MENU.DASHBOARD.SUCCESS'],
            icon: 'success',
            confirmButtonText: translations['MENU.DASHBOARD.OK']
          }).then(() => this.router.navigate(['/open-screen']));
        });
    },
    error: (err) => {
      this.loading.hide();

      // Map server validation errors
      const errors = err?.error || {};
      let errorMsg = '';
      for (const key of ['name_ar', 'name_en', 'body_ar', 'body_en', 'image']) {
        if (errors[key]) {
          errorMsg += errors[key].join(', ') + '\n';
        }
      }

      if (!errorMsg) {
        errorMsg = err?.message || 'Unexpected error occurred';
      }

      this.translate.get(['MENU.DASHBOARD.ERROR', 'MENU.DASHBOARD.OK']).subscribe(translations => {
        Swal.fire({
          title: translations['MENU.DASHBOARD.ERROR'],
          text: errorMsg,
          icon: 'error',
          confirmButtonText: translations['MENU.DASHBOARD.OK']
        });
      });
    }
  });
}

}

